
export const network = {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  api_route: 'api',
  auth_route: 'OAuth',
  timeout: 30000,
  signalRTimeout: 60000, // timeout مخصوص SignalR
  heartbeatInterval: 30000, // interval برای heartbeat
};

export const market = 'googleplay'; //Market: "googleplay" | "cafebazaar" | "myket" | "site" | "pwa" | "develop"
